import {
	REGISTRATION_PAGE_ID,
	REGISTRATION_SCENARIO_ID,
	isRegistrationScenario,
	createRegistrationScenario,
} from "./escapeRoomEditorConstants";

export function pageId(p) {
	return p?.pageId || p?._id;
}

export function isRegistrationPage(page) {
	return pageId(page) === REGISTRATION_PAGE_ID;
}

export function getScenarioBlockKey(page) {
	return isRegistrationPage(page) ? REGISTRATION_SCENARIO_ID : String(page?.scenarioId || "");
}

export function isPageInScenario(page, scenarioId) {
	return getScenarioBlockKey(page) === String(scenarioId);
}

export function getPlayableScenarios(scenarios) {
	return (scenarios || []).filter((s) => !isRegistrationScenario(s));
}

export function getDefaultPlayableScenarioId(scenarios) {
	return getPlayableScenarios(scenarios)[0]?.id || "";
}

export function getScenarioBlockOrderFromPages(pages) {
	const keys = [];
	for (const p of pages || []) {
		const k = getScenarioBlockKey(p);
		if (k && !keys.includes(k)) keys.push(k);
	}
	return keys;
}

/** Garantiza el escenario «Registro» y sincroniza su orden con la posición actual en páginas. */
export function ensureRegistrationScenario(scenarios, pages) {
	const playable = (scenarios || []).filter((s) => !isRegistrationScenario(s));
	let regSc = (scenarios || []).find((s) => isRegistrationScenario(s));
	const blockOrder = getScenarioBlockOrderFromPages(pages);
	const withReg = [
		...playable,
		{
			...(regSc || createRegistrationScenario(0)),
			id: REGISTRATION_SCENARIO_ID,
			isRegistration: true,
			name: "Registro",
			icon: "assignment",
		},
	];
	const sorted = [...withReg].sort((a, b) => {
		const aKey = isRegistrationScenario(a) ? REGISTRATION_SCENARIO_ID : String(a.id);
		const bKey = isRegistrationScenario(b) ? REGISTRATION_SCENARIO_ID : String(b.id);
		const ai = blockOrder.indexOf(aKey);
		const bi = blockOrder.indexOf(bKey);
		const aPos = ai >= 0 ? ai : 1000 + (a.order ?? 0);
		const bPos = bi >= 0 ? bi : 1000 + (b.order ?? 0);
		if (aPos !== bPos) return aPos - bPos;
		return String(aKey).localeCompare(String(bKey));
	});
	return sorted.map((s, i) => ({ ...s, order: i }));
}
